import React from 'react';

const PlayerControlSelections = ({
  matchStatus,
  quarter,
  made1PT,
  made2PT,
  made3PT,
  miss1PT,
  miss2PT,
  miss3PT,
  foulActions,
  toActions,
  handleSelectPoint,
  handleWarningMassage,
  setStarState,
  starState,
  star_logo,
  setMiss1PTActive,
}) => {
  return (
    <div className="xxl:max-w-[570px] xxl:min-w-[570px] max-w-[244px] lg:max-w-[596px] lg:min-w-[596px] min-w-[244px]  w-full relative  p-1  lg:p-6 pr-0 lg:pr-0 flex flex-col gap-[10px] lg:gap-[23px]">
      {matchStatus == "Waiting to start" && (
        <div
          onClick={() => handleWarningMassage()}
          className="absolute bg-transparent text-gray-700 text-6xl flex justify-center items-center text-center font-bebas  bg-opacity-40 w-full h-full z-10"
        ></div>
      )}
      {quarter == "Final" && (
        <div
          onClick={() => handleWarningMassage()}
          className="absolute bg-transparent text-gray-700 text-6xl flex justify-center items-center text-center font-bebas  bg-opacity-40 w-full h-full z-10"
        ></div>
      )}
      <div className="flex gap-[6px] md:gap-[10px] lg:gap-[23px]">
        <button
          disabled={!made1PT == "active"}
          onClick={() => handleSelectPoint("MADE_1_PT")}
          className={`max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px] lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center
              ${made1PT === true
              ? "text-[#C08C5E] cursor-pointer"
              : made1PT == "active"
                ? " bg-[#419066] text-light"
                : "text-[#EBEBEB] cursor-not-allowed"
            }`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          1pt made
        </button>
        <button
          disabled={!made3PT == "active"}
          onClick={() => handleSelectPoint("MADE_3_PT")}
          className={`max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center
              ${made3PT === true
              ? "text-[#C08C5E] cursor-pointer"
              : made3PT == "active"
                ? " bg-[#419066] text-light"
                : "text-[#EBEBEB] cursor-not-allowed"
            }`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          3pt made
        </button>
        <button
          disabled={!made2PT == "active"}
          onClick={() => handleSelectPoint("MADE_2_PT")}
          className={`max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center
              ${made2PT === true
              ? "text-[#C08C5E] cursor-pointer"
              : made2PT == "active"
                ? " bg-[#419066] text-light"
                : "text-[#EBEBEB] cursor-not-allowed"
            }`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          2pt made
        </button>
      </div>

      <div className="flex gap-[6px] md:gap-[10px] lg:gap-[23px] ">
        <button
          onClick={() => [
            handleSelectPoint("MISS_1_PT"),
            setMiss1PTActive(true),
          ]}
          className={`max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center
              ${miss1PT === true
              ? "text-[#D54043] cursor-pointer"
              : miss1PT == "active"
                ? " bg-[#419066] text-light"
                : "text-[#EBEBEB] cursor-not-allowed"
            }`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          1pt miss
        </button>
        <button
          onClick={() => [
            handleSelectPoint("MISS_3_PT"),
            setMiss1PTActive(false),
          ]}
          className={`max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center
              ${miss3PT === true
              ? "text-[#D54043] cursor-pointer"
              : miss3PT == "active"
                ? " bg-[#419066] text-light"
                : "text-[#EBEBEB] cursor-not-allowed"
            }`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          3pt miss
        </button>
        <button
          onClick={() => [
            handleSelectPoint("MISS_2_PT"),
            setMiss1PTActive(false),
          ]}
          className={`max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center
              ${miss2PT === true
              ? "text-[#D54043] cursor-pointer"
              : miss2PT == "active"
                ? " bg-[#419066] text-light"
                : "text-[#EBEBEB] cursor-not-allowed"
            }`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          2pt miss
        </button>
      </div>
      <div className="flex gap-[6px] md:gap-[10px] lg:gap-[23px] items-center">
        <div className="max-w-[72px] md:max-w-[175px] relative  w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg text-[#D54043] leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center">
          <div
            className="max-w-[59.28px] lg:max-w-[140px] w-full lg:h-[140px] h-[59.28px] rounded-full text-[#D54043] leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center"
            style={{
              boxShadow:
                "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
            }}
          >
            {starState && (
              <div
                onClick={() => setStarState(!starState)}
                className="absolute max-w-[53.35px] lg:max-w-[126px] cursor-pointer w-full lg:h-[126px] h-[53.35px]  bg-gray-300 bg-opacity-80 rounded-full"
              ></div>
            )}
            <img
              onClick={() => setStarState(!starState)}
              className="max-w-[53.35px] lg:max-w-[126px] cursor-pointer  w-full lg:h-[126px] h-[53.35px] rounded-full "
              src={star_logo}
              alt=""
              srcSet=""
            />
          </div>
        </div>

        <button
          onClick={() => handleSelectPoint("FOUL_ACTIONS")}
          className={`max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] cursor-pointer rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center
              ${foulActions === true
              ? "text-[#D54043] cursor-pointer"
              : foulActions == "active"
                ? " bg-[#419066] text-light"
                : "text-[#EBEBEB] cursor-not-allowed"
            }
              `}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          Foul
        </button>
        <button
          onClick={() => handleSelectPoint("TO_PT")}
          className={`max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] cursor-pointer rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center
              ${toActions === true
              ? "text-[#D54043] cursor-pointer"
              : toActions == "active"
                ? " bg-[#419066] text-light"
                : "text-[#EBEBEB] cursor-not-allowed"
            }
              `}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          TO
        </button>
      </div>
    </div>
  );
};

export default PlayerControlSelections;